import styled from 'styled-components';

export const BreadcrumbText = styled.span`
    font-size: 1.4rem;
    font-weight: bold;
    cursor: pointer;
`;

export const BreadcrumbSeparator = styled.span`
    font-size: 1.4rem;
    font-weight: bold;
`;

export const FolderName = styled.span`
    padding-left: 1rem;
    cursor: pointer;
`;
